import React from "react";
import DashboardLayout from "../../components/DashboardLayout/DashboardLayout";
import "./HelpPage.css";
import { FaUserAlt } from "react-icons/fa";
// import { IoIosMailOpen } from "react-icons/io";
import { GrStripe } from "react-icons/gr";
import { IoIosHeart } from "react-icons/io";
import { FaPaypal } from "react-icons/fa";
import { FaList } from "react-icons/fa";
import { BrowserView, MobileView } from 'react-device-detect'
import MobileTopBar from "../../components/common/MobileTopBar";
import fundraiser from "../../images/fundraiser-icon-new.png";
// SVG lives in `public/icons/` — reference it by URL instead of importing from outside `src`
const neddieIntegration = '/icons/neddie_integeration.svg';


const cards = [
  { key: "general", label: "General & FAQs", icon: "list", url: "https://www.neddieblog.com/faqs" },
  { key: "stripe", label: "Stripe Guide", icon: "stripe", url: "/downloads/Create a Stripe Account.pdf" },
  { key: "paypal", label: "PayPal Guide", icon: "paypal", url: "/downloads/Create a PayPal Account Guide.pdf" },
  { key: "neddie-payment-option-A", label: "NEDDIE Payments", label2: '(Option A-API, Checkout Box Only)', icon: "integeration", url: "/downloads/NEDDIE Payments Box API- User Guide.pdf" },
  { key: "neddie-payment-option-B", label: "NEDDIE Payments", label2: ' (Option B-Customizable Donate Page)', icon: "integeration", url: "/downloads/NEDDIE Payments Whitelabel - User Guide.pdf" },
  { key: "profile", label: "How To Edit Profile", icon: "user", url: "https://www.neddieblog.com/_files/ugd/a8f50b_3a661c28ea7b4cfd911ec6a8c8516f1a.pdf" },
  { key: "fundraiser", label: "Fundraiser Section", icon: "mail", url: "https://www.neddieblog.com/_files/ugd/a8f50b_07040b5f3bcf4519bcde3452d97d9f17.pdf" },
  { key: "impact", label: "Impact Section", icon: "hearthand", url: "https://www.neddieblog.com/_files/ugd/a8f50b_97ba89db3a7a4868b0ef2b4521dcbd62.pdf" },
];

export default function HelpPage() {
  return (
    <>
      <BrowserView>
        <DashboardLayout>
          <div className="help-page">
            <h1 className="hp-title">Get Help</h1>

            <div className="hp-grid">
              {cards.map((c) => (
                <div className="hp-card" onClick={() => window.open(c.url, "_blank")}>

                  <span className="hp-icon mb-3">{getIcon(c.icon)}</span>

                  <label htmlFor="">
                    <span className="hp-card-label">{c.label}</span>
                    <span className="hp-card-label">{c.label2}</span>
                  </label>
                </div>
              ))}
            </div>

            <div className="hp-search">
              {/* <span className="hp-search-icon" aria-hidden="true">
            {getIcon("search")}
          </span> */}
              <input
                className="hp-search-input"
                placeholder="Can’t find what you are looking for?"
              />
              <a className="hp-contact-btn" href="https://www.neddieblog.com/contact">
                Contact us
              </a>
            </div>
          </div>
        </DashboardLayout>
      </BrowserView>
      <MobileView>
        <MobileTopBar />
        <div className="help-page">
          <h1 className="hp-title">Get Help</h1>

          <div className="hp-grid">
            {cards.map((c) => (
              <div className="hp-card" onClick={() => window.open(c.url, "_blank")}>

                <span className="hp-icon mb-3">{getIcon(c.icon)}</span>

                <label htmlFor="">
                  <span className="hp-card-label">{c.label}</span>
                  <span className="hp-card-label">{c.label2}</span>
                </label>
              </div>
            ))}
          </div>

          <div className="hp-search">
            {/* <span className="hp-search-icon" aria-hidden="true">
            {getIcon("search")}
          </span> */}
            <input
              className="hp-search-input"
              placeholder="Can’t find what you are looking for?"
            />
            <a className="hp-contact-btn" href="https://www.neddieblog.com/faqs">
              Contact us
            </a>
          </div>
        </div>
      </MobileView>
    </>

  );
}

/* ——— Icons (inline SVG to match the screenshot color/feel) ——— */
function getIcon(name: string) {
  switch (name) {
    case "list":
      return (
        <FaList style={{ fontSize: "60px", color: "#5c6df6" }} />
      );
    case "stripe":
      return (
        <GrStripe style={{ fontSize: "60px", color: "#5c6df6" }} />
      );
    case "paypal":
      return (
        <FaPaypal style={{ fontSize: "60px", color: "#5c6df6" }} />
      );
    case "user":
      return (
        // <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
        //   <circle cx="30" cy="22" r="10" fill="#5c6df6" />
        //   <rect x="12" y="36" width="36" height="16" rx="8" fill="#5c6df6" />
        // </svg>
        <FaUserAlt style={{ fontSize: "60px", color: "#5c6df6" }} />
      );
      case "mail":
      return (
        <img src={fundraiser} alt="" width={60} />
        // <IoIosMailOpen style={{ fontSize: "60px", color: "#5c6df6" }} />
      );
      case "integeration":
      return (
        <img src={neddieIntegration} alt="" width={100} />
      );
      case "integertaion":
      // tolerate the misspelling if present elsewhere
      return (
        <img src={neddieIntegration} alt="" width={100} />
      );
    case "hearthand":
      return (
        <IoIosHeart style={{ fontSize: "60px", color: "#5c6df6" }} />
      );
    case "search":
      return (
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
          <circle cx="11" cy="11" r="7" stroke="#2e2e2e" strokeWidth="2" />
          <path d="M20 20l-3.5-3.5" stroke="#2e2e2e" strokeWidth="2" />
        </svg>
      );
    default:
      return null;
  }
}
